import script from "./GroupDeleteDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupDeleteDialog.vue?vue&type=script&lang=ts&setup=true"

import "./GroupDeleteDialog.vue?vue&type=style&index=0&id=5b3081ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3081ba"]])

export default __exports__